import { Box, Stack, Alert, Skeleton } from "@mui/material";
import VariableResult from "catalog/components/VariableResult";
import useCatalogSearch, { PAGE_SIZE } from "catalog/hooks/useCatalogSearch";
import EmptyState from "~/components/EmptyState";
import LimitedPagination from "~/components/LimitedPagination";
import { useDocumentTitle } from "~/hooks/useDocumentTitle";
import { VariableEntity } from "~/types/interfaces/catalogResponse";

const Variables = () => {
  useDocumentTitle("Columns");
  // Note: App header is managed by DataBrowser parent component
  const { data, error, isLoading } = useCatalogSearch<VariableEntity>("column");
  const variables = data?.hits?.hits.filter(({ _source }) => _source.entityType === "column") ?? [];
  const total = data?.hits?.total?.value ?? 0;

  if (error) {
    return (
      <Box sx={{ px: 4, py: 2, minHeight: "100%" }}>
        <Alert severity="error" variant="outlined">
          An error occurred fetching search results.
        </Alert>
      </Box>
    );
  }

  return (
    <Box sx={{ px: 4, py: 1, minHeight: "100%" }}>
      <Stack flex={1}>
        {variables.map(({ _source: variable, highlight }) => (
          <VariableResult
            key={variable.fullyQualifiedName}
            entity={variable}
            highlight={highlight}
            hoverable
          />
        ))}
        {!variables.length &&
          isLoading &&
          Array.from({ length: 6 }).map((_, i) => (
            <Skeleton key={i} height={120} variant="rounded" sx={{ my: 2 }} />
          ))}
        {variables.length === 0 && !isLoading && <EmptyState />}
      </Stack>
      <LimitedPagination total={total} defaultPageSize={PAGE_SIZE} />
    </Box>
  );
};

export default Variables;
